import PosterSwipe from "@/components/poster-swiper";
import SortIcon from "@/components/sort-icon";
import Tabs from "@/components/tabs";
import TopBack from "@/components/top-back";
import { ActivityCardNormalV2Comp } from "@akc/mx-taro-h5-components";
import { InfiniteScroll, Loading, SafeArea, Skeleton } from "antd-mobile";
import React, { useRef } from "react";
import useForcast from "./hooks/useForcast";
import styles from "./index.module.less";

const Forcast: React.FC = () => {
  const {
    // 状态
    activeIndex,
    tabsArr,
    activityList,
    finished,
    commonContext,
    forwarded,
    showHidden,
    open,
    sortObjRef,
    pageObj,
    scrollContainerRef,
    // 方法
    setActiveIndexHandler,
    onLoad,
    clickHandle,
    getScreenProduct,
    // 常量
    SORT_OPTIONS_ADMIN,
    SORT_OPTIONS_C,
    track,
    navigate,
  } = useForcast();

  return (
    <div
      ref={scrollContainerRef}
      className={styles.container + " " + (open ? styles.mask : "")}
      onClick={() => {
        console.log("点击容器");
      }}>
      <TopBack top="45px" />
      {/* 标签页 - 使用统一的Tabs组件 */}
      <div className={styles.tabs_wrapper}>
        <Tabs
          data={tabsArr.map((item, index) => ({
            text: item.activityTagName,
          }))}
          color="#666"
          activeColor="#ff4747"
          showFull
          activeIndex={activeIndex}
          onChange={index => setActiveIndexHandler(index)}
        />
      </div>

      {/* 排序和筛选 */}
      <div className={styles.dropdownMenu_wrap}>
        {/* 排序组件 - 非C角色专用 */}
        {commonContext.currentRole !== "C" && (
          <div className={styles.sort_wrapper_admin}>
            {SORT_OPTIONS_ADMIN.map((option, idx) => (
              <div
                key={idx}
                className={`${styles.sort_option_admin} ${String(sortObjRef.current.sortedModel) === option.value ? styles.active_admin : ""}`}
                onClick={() =>
                  clickHandle({
                    sortedModel: parseInt(option.value),
                    sortedType: option.arrowType || 2,
                  })
                }>
                <span className={styles.sort_text}>{option.text}</span>
                {option.arrowType && (
                  <SortIcon
                    sortType={
                      String(sortObjRef.current.sortedModel) === option.value
                        ? sortObjRef.current.sortedType
                        : 0
                    }
                  />
                )}
              </div>
            ))}
          </div>
        )}

        {/* 排序组件 - C角色专用 */}
        {commonContext.currentRole === "C" && (
          <div className={styles.sort_wrapper_c}>
            {SORT_OPTIONS_C.map((option, idx) => (
              <div
                key={idx}
                className={`${styles.sort_option_c} ${String(sortObjRef.current.sortedModel) === option.value ? styles.active_c : ""}`}
                onClick={() =>
                  clickHandle({
                    sortedModel: parseInt(option.value),
                    sortedType: option.arrowType || 2,
                  })
                }>
                <span className={styles.sort_text}>{option.text}</span>
                {option.arrowType && (
                  <SortIcon
                    sortType={
                      String(sortObjRef.current.sortedModel) === option.value
                        ? sortObjRef.current.sortedType
                        : 0
                    }
                  />
                )}
              </div>
            ))}
          </div>
        )}

        {/* 筛选组件 - 分角色展示 */}
        {(commonContext.currentRole === "E" || commonContext.currentRole === "A") && (
          <div className={styles.filter_wrapper_admin}>
            <div className={styles.filter_row_admin}>
              <div
                className={`${styles.filter_item_admin} ${showHidden === true ? styles.active_filter_admin : ""}`}
                onClick={() => getScreenProduct({ showHidden: "show" })}>
                <span className={styles.filter_text}>已隐藏</span>
              </div>
              <div
                className={`${styles.filter_item_admin} ${showHidden === false ? styles.active_filter_admin : ""}`}
                onClick={() => getScreenProduct({ showHidden: "hide" })}>
                <span className={styles.filter_text}>未隐藏</span>
              </div>
              <div
                className={`${styles.filter_item_admin} ${forwarded === true ? styles.active_filter_admin : ""}`}
                onClick={() => getScreenProduct({ forwarded: true })}>
                <span className={styles.filter_text}>已转发</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 活动列表 */}
      <div className={styles.activity_list}>
        {pageObj?.current.pageNum === 1 &&
          activityList?.length <= 0 &&
          !finished &&
          new Array(3)
            .fill(0)
            .map((_, index) => <Skeleton key={index} animated className={styles.cardSkeleton} />)}
        {activityList.length > 0 &&
          activityList.map((item, index) => (
            <ActivityCardNormalV2Comp
              model={item}
              style={{ margin: "0 0 8px 0" }}
              key={item.uniKey || index}
              trackData={{
                domain: "预告",
              }}
              mainLocationCode="H5_ScheduleList_BrandDown"
              productTLLocationCode="H5_ScheduleList_TopProductPicLeft"
              productTRLocationCode="H5_ScheduleList_TopProductPicRight"
            />
          ))}

        <InfiniteScroll loadMore={onLoad} hasMore={!finished} threshold={0}>
          <div className={styles.load_more_text}>
            {finished ? "好东西就到这里啦~" : pageObj?.current.pageNum !== 1 ? "加载中..." : ""}
          </div>
        </InfiniteScroll>
      </div>

      {/* 底部安全区域 */}
      <SafeArea position="bottom" />
    </div>
  );
};

export default Forcast;
